import type { FaireProductEntity } from "../../entity_types/product";

export const p_b6tzqppdc4: FaireProductEntity = {
  token: "p_b6tzqppdc4",
  type: "product",
  name: "Rainbow Blocks",
  brandToken: "b_zdxcxuak9e",
  brandName: "Nova Toys LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/5fb702207e1208ce3d2f69e6de9d73f0febd7d0ca6e0a226d00926654dee669e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e682e583ab38c819dc99ba8e5c075f52fcc80758e77ba80dcface7e2057f5e2.jpeg",
    "https://cdn.faire.com/fastly/87340126bc4fdcf9a440c4d2811aaeb3498e3a82a4ca91244ef8fb25296adabf.jpeg",
    "https://cdn.faire.com/fastly/b9a14423172a5314e59aca56aeca6baaed136a1af7b7741e62d16c44950dd8f1.jpeg",
    "https://cdn.faire.com/fastly/cd798712a556906a3323cf0e5a855e9f703507fe4ed872d2f3fdf74c0839b782.jpeg",
    "https://cdn.faire.com/fastly/dfd15931743c397c5480707aa54f383952dff2627c0e522f5abbb0d7db2d9422.jpeg",
    "https://cdn.faire.com/fastly/ea2d6b77ff17222bd644a219ae13d2d123a45eba220e2f1ab81495043cc8e194.jpeg",
    "https://cdn.faire.com/fastly/08bfc563a4d357ade1c2c74b2e6d0625416fdd3e0dc31129c7a0b4cc96b2784f.jpeg",
    "https://cdn.faire.com/fastly/4e312605ba4440aee637cd7f6f2460fb612be0168c979b19c30267a5c7d1c7d9.jpeg",
    "https://cdn.faire.com/fastly/8a8e61b1058b2d79d9de76d902110b0af7b3c6332efa3dd385a215061032281b.jpeg",
    "https://cdn.faire.com/fastly/8116def3f13a5aba062d5ea403f61cefd17fe1662920049556e28c28f468a17d.jpeg",
    "https://cdn.faire.com/fastly/c8e024d8141f32eb83cb32497eca6efa7f32c34cebae6297e584d0959554a94c.jpeg",
  ],
  priceDollars: 25,
  description:
    "Stack, sort, and imagine with KIPOD Rainbow Blocks—a colorful wooden play set designed to inspire creativity and open-ended play. This beautiful set includes 25 vibrant blocks in various shapes, 5 charming wooden characters, and a sturdy wooden tray for easy storage and display. Perfect for building towers, creating scenes, or mixing colors and shapes, Rainbow Blocks support the development of fine motor skills, spatial awareness, and storytelling. Crafted from high-quality wood and designed with care, this set offers endless possibilities for hands-on exploration.",
  tags: [],
  msrpDollars: 49.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:05.221Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
